import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

/**
 * Setup billing for an organization
 * @param {object} data - Billing setup data
 * @returns {Promise<object>}
 */
export const setupBilling = async (data) => {
  try {
    const setupBillingFunction = httpsCallable(functions, 'setupBilling');
    const result = await setupBillingFunction(data);
    return result.data;
  } catch (error) {
    console.error('Error setting up billing:', error);
    throw error;
  }
};

/**
 * Get billing information for an organization
 * @param {string} domain - Organization domain
 * @returns {Promise<object>}
 */
export const getBillingInfo = async (domain) => {
  try {
    const getBillingInfoFunction = httpsCallable(functions, 'getBillingInfo');
    const result = await getBillingInfoFunction({ domain });
    return result.data;
  } catch (error) {
    console.error('Error getting billing info:', error);
    throw error;
  }
};

/**
 * Get invoices for an organization
 * @param {string} domain - Organization domain
 * @returns {Promise<object>}
 */
export const getInvoices = async (domain) => {
  try {
    const getInvoicesFunction = httpsCallable(functions, 'getInvoices');
    const result = await getInvoicesFunction({ domain });
    return result.data;
  } catch (error) {
    console.error('Error getting invoices:', error);
    throw error;
  }
};
